module.exports = __webpack_public_path__ + "static/RTR_WP-3-Optimization-Core-Results-8906a8402d6afd7f60d96f366eae4758.pdf";